import React from "react";
import { TopBar } from "../components/landing/TopBar";
import { Header } from "../components/landing/Header";
import { Hero } from "../components/landing/Hero";
import { TrustStrip } from "../components/landing/TrustStrip";
import { ServicesGrid } from "../components/landing/ServicesGrid";
import { ServiceDetails } from "../components/landing/ServiceDetails";
import { BookingSection } from "../components/BookingSection";
import { FAQSection } from "../components/landing/FAQSection";
import { ContactSection } from "../components/landing/ContactSection";
import { Footer } from "../components/landing/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background text-left">
      <TopBar />
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <ServicesGrid />
        <ServiceDetails />
        <BookingSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
